export default __webpack_public_path__ + "static/media/white_building_icon.2d68ab25.svg";